document.addEventListener('DOMContentLoaded', function() {
  // 汇率：1 USD = 160 JPY
  const EXCHANGE_RATE = 160;

  // 转换为日元的价格
  var equipPriceJPY = 698 * EXCHANGE_RATE;        // 设备+首套墨盒：111,680 JPY
  var refillCartridgeJPY = 59 * EXCHANGE_RATE;     // 额外墨盒：9,440 JPY

  // 单次打印耗材成本（日元）
  var inkPerPrintJPY = refillCartridgeJPY / 3000;  // ≈ 3.1467 JPY

  var equipInput = document.getElementById('equipmentCost');
  var printsInput = document.getElementById('dailyPrints');
  var chargeInput = document.getElementById('extraCharge');

  if (!equipInput || !printsInput || !chargeInput) return;

  function updateROI() {
    // 读取输入值（日元）
    var equipCost = parseFloat(equipInput.value) || equipPriceJPY;
    var daily = parseInt(printsInput.value);
    var charge = parseFloat(chargeInput.value);

    // 更新显示标签（显示日元符号）
    document.getElementById('dailyPrintsValue').textContent = daily;
    document.getElementById('extraChargeValue').textContent = '¥' + charge.toFixed(2);

    var dailyInk = daily * inkPerPrintJPY;
    var dailyRev = daily * charge;
    var dailyNet = dailyRev - dailyInk;
    var paybackDays = dailyNet > 0 ? Math.ceil(equipCost / dailyNet) : '∞';
    var monthlyNet = dailyNet * 30;

    document.getElementById('dailyInkCost').textContent = '¥' + dailyInk.toFixed(2);
    document.getElementById('dailyRevenue').textContent = '¥' + dailyRev.toFixed(2);
    document.getElementById('dailyProfit').textContent = '¥' + dailyNet.toFixed(2);
    document.getElementById('paybackPeriod').textContent = '~' + paybackDays + ' days';
    document.getElementById('monthlyProfit').textContent = '¥' + monthlyNet.toFixed(2);
  }

  equipInput.addEventListener('input', updateROI);
  printsInput.addEventListener('input', updateROI);
  chargeInput.addEventListener('input', updateROI);

  // 设置默认值（日元）
  equipInput.value = equipPriceJPY;
  chargeInput.value = 80;   // 假设默认收费80日元（约0.5美元）

  updateROI();
});